var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.8721,
    cy: 23.2842,
    r: 22.5225,
    fill: "url(#paint0_linear_148_231)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.64659 16.2625C10.9479 13.6713 12.9442 11.4929 15.4124 9.97103C17.8806 8.44913 20.7234 7.64362 23.6231 7.64453C27.8382 7.64453 31.3793 9.19452 34.0867 11.7189L29.6025 16.2047C27.9805 14.6547 25.9191 13.8648 23.6231 13.8648C19.5487 13.8648 16.0999 16.6176 14.8721 20.3135C14.5593 21.2519 14.381 22.2529 14.381 23.2852C14.381 24.3175 14.5593 25.3185 14.8721 26.2569C16.1015 29.9543 19.5487 32.7055 23.6231 32.7055C25.7267 32.7055 27.5176 32.1503 28.919 31.2119C29.7314 30.6769 30.4269 29.9828 30.9635 29.1715C31.5001 28.3602 31.8666 27.4485 32.0409 26.4915H23.6231V20.4417H38.3534C38.538 21.4646 38.6381 22.5313 38.6381 23.6402C38.6381 28.4044 36.9332 32.4146 33.974 35.1361C31.3871 37.526 27.846 38.9258 23.6231 38.9258C21.5689 38.9266 19.5347 38.5226 17.6367 37.7369C15.7387 36.9512 14.0142 35.7991 12.5616 34.3466C11.1091 32.8941 9.95705 31.1695 9.17132 29.2716C8.3856 27.3736 7.9816 25.3394 7.98242 23.2852C7.98242 20.7608 8.58615 18.374 9.64659 16.2625Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_148_231",
    x1: 22.8721,
    y1: 0.761719,
    x2: 22.8721,
    y2: 45.8068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B426D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7419FB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google-icon.89cb4206610f9d3c69ff5ea76a197e53.svg";
export { ForwardRef as ReactComponent };